window.addEventListener("message", (event) => {
    // Ensure the message comes from the trusted iframe origin
    if (event.origin !== "https://builderportal.hcraontario.ca") {
        return;
    }

    if (event.data && event.data.height) {
        const iframes = [
            document.getElementById("iFrame-builder-vendor-complaint"),
            document.getElementById("iFrame-building-compliant"),
        ];

        iframes.forEach((iframe) => {
            if (iframe && iframe.contentWindow === event.source) {
                iframe.style.height = event.data.height + "px";
            }
        });
    }

    console.log(event.data); 
});